import recapLogo from './recapLogo.svg';
import { ClarionSpinner } from '../clarion/ClarionSpinner';

const features = [
  {
    title: 'Effortless Transcription & Closed-Captioning',
    description: 'Our AI engine accurately transcribes your video content in 115+ languages, generating clean and searchable text for easy access.',
  },
  {
    title: 'Global Translation',
    description: 'Translate your content into 190+ languages, breaking down language barriers and opening your lectures to the world.',
  },
  {
    title: 'Instant AI Voiceovers',
    description: 'Seamlessly transform your translated transcripts into spoken content with AI voiceovers in 650+ options for languages, dialects, and voices.',
  },
  {
    title: 'AI Audio Descriptions',
    description: 'Generate audio descriptions of visual elements on screen, allowing individuals with visual impairments to fully engage with your video content.',
  },
];

export default function EmbedLoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#d6caeb] to-[#a26dff] dark:from-[#2a1b4d] dark:to-[#1a0f33] flex flex-col items-center justify-center p-4 md:p-8">
      <div className="max-w-4xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 md:p-8">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src={recapLogo} alt="" className="h-10 w-10" />
          <h1 className="text-2xl font-bold m-0">Recap Innovations</h1>
        </div>
        
        <div className="flex justify-center mb-8">
          <ClarionSpinner size={30} />
          <h2 className="text-2xl font-bold m-0">Loading your content...</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature) => (
            <div key={feature.title} className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
              <h2 className="text-lg font-semibold mb-2">{feature.title}</h2>
              <p className="text-sm opacity-70 m-0">{feature.description}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm opacity-70 mt-8 mb-0">
          Powered by Recap Innovations LLC
        </p>
      </div>
    </div>
  );
} 